import apiReporting from '@/api/reporting'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getReportingByParamsStart: '[reporting] Get reporting by params start',
  getReportingByParamsSuccess: '[reporting] Get reporting by params success',
  getReportingByParamsFailure: '[reporting] Get reporting by params failure',
}

export const actionTypes = {
  getReportingByParams: '[reporting] Get reporting by params',
}

const mutations = {
  [mutationTypes.getReportingByParamsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getReportingByParamsSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getReportingByParamsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getReportingByParams](context, {params}) {
    context.commit(mutationTypes.getReportingByParamsStart)
    return new Promise((resolve) => {
      apiReporting
        .getReportingByParams(params)
        .then((response) => {
          const reporting = response.data ? response.data : response
          context.commit(mutationTypes.getReportingByParamsSuccess, response)
          resolve(reporting.list)
        })
        .catch(() => {
          context.commit(mutationTypes.getReportingByParamsFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
